// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { useMutation } from '@tanstack/react-query'

import { type Reimbursement } from 'components/admin/types'

import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

export type ModifyReimbursmentsParams = {
  broker_ids_to_add?: string[]
  broker_ids_to_remove?: string[]
}

export function useModifyReimbursments ({ ids } : { ids: string[] }) {
  return useMutation<Reimbursement[], GrapeAPIErrorType, ModifyReimbursmentsParams>({
    mutationFn: async (params) => {
      const request = new FetchRequest(
        'patch',
        '/api/web/admin/reimbursements',
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: {
            reimbursement_ids: ids,
            ...params,
          },
        }
      )
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return response.json
    },
  })
}
